"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO(#323): remove on v6, use radash memo instead https://radash-docs.vercel.app/docs/curry-memo
/** @deprecated use radash memo instead https://radash-docs.vercel.app/docs/curry-memo  */
function once(f) {
    let value = null;
    return function (...args) {
        if (!value) {
            value = { result: f(...args) };
        }
        return value.result;
    };
}
exports.default = once;
